<div class="super-admin-padding">
  <div class="super-admin-page theme-background-color">
    <div class="super-admin-header">Super admin</div>
    <h1>Account detail</h1>

    <div *ngIf="account">
      <p>Name: {{ account.name }}</p>
      <p>Account ID: {{ account._id }}</p>
      <p>Email: {{ account.email }}</p>
      <p>Super admins: {{ account.superAdmins }}</p>
      <p>Created: {{ account.createdAtString }}</p>
      <p>Updated: {{ account.updatedAtString }}</p>
      <p>Banned: {{ account.bannedAt }}</p>
    </div>

    <div *ngIf="orgs">
      <mat-divider></mat-divider>
      <h3>Orgs</h3>

      <table mat-table [dataSource]="orgs" class="mat-elevation-z8">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Org</th>
          <td mat-cell *matCellDef="let element">
            <a [routerLink]="element.orgLink">{{ element.name }}</a>
          </td>
        </ng-container>

        <!-- Spaces Column -->
        <ng-container matColumnDef="userSpacesString">
          <th mat-header-cell *matHeaderCellDef>Spaces</th>
          <td mat-cell *matCellDef="let element">
            <a [routerLink]="element.orgLink">{{ element.userSpacesString }}</a>
          </td>
        </ng-container>

        <!-- createdAt Column -->
        <ng-container matColumnDef="createdAtString">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let element">
            <a [routerLink]="element.orgLink">{{ element.createdAtString }}</a>
          </td>
        </ng-container>

        <!-- updatedAt Column -->
        <ng-container matColumnDef="updatedAtString">
          <th mat-header-cell *matHeaderCellDef>Updated</th>
          <td mat-cell *matCellDef="let element">
            <a [routerLink]="element.orgLink">{{ element.updatedAtString }}</a>
          </td>
        </ng-container>

        <!-- _id Column -->
        <ng-container matColumnDef="_id">
          <th mat-header-cell *matHeaderCellDef>id</th>
          <td mat-cell *matCellDef="let element">
            <a [routerLink]="element.orgLink">{{ element._id }}</a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="orgDisplayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: orgDisplayedColumns"
          [routerLink]="row.orgLink"
        ></tr>
      </table>
    </div>

    <div *ngIf="sessions">
      <mat-divider></mat-divider>

      <h3>Sessions</h3>

      <table mat-table [dataSource]="sessions" class="mat-elevation-z8">
        <!-- _id Column -->
        <ng-container matColumnDef="_id">
          <th mat-header-cell *matHeaderCellDef>Session ID</th>
          <td mat-cell *matCellDef="let element">
            {{ element._id }}
          </td>
        </ng-container>

        <!-- clientId Column -->
        <ng-container matColumnDef="clientId">
          <th mat-header-cell *matHeaderCellDef>clientId</th>
          <td mat-cell *matCellDef="let element">
            {{ element.clientId }}
          </td>
        </ng-container>

        <!-- createdAt Column -->
        <ng-container matColumnDef="createdAtString">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdAtString }}
          </td>
        </ng-container>

        <!-- updatedAt Column -->
        <ng-container matColumnDef="updatedAtString">
          <th mat-header-cell *matHeaderCellDef>Updated</th>
          <td mat-cell *matCellDef="let element">
            {{ element.updatedAtString }}
          </td>
        </ng-container>

        <!-- expiresAt Column -->
        <ng-container matColumnDef="expiresAtString">
          <th mat-header-cell *matHeaderCellDef>Expires</th>
          <td mat-cell *matCellDef="let element">
            {{ element.expiresAtString }}
          </td>
        </ng-container>

        <!-- userAgent Column -->
        <ng-container matColumnDef="userAgent">
          <th mat-header-cell *matHeaderCellDef>userAgent</th>
          <td mat-cell *matCellDef="let element">
            {{ element.userAgent }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="sessionDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: sessionDisplayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
